import { Button } from 'react-bootstrap';
import { CustomButtonProps } from './custom-button-props.interface';
import { useButtonNavHandler } from './hooks/use-button-nav-handler';
import './button.component.scss';

export const ButtonPrimary = ({
  children,
  path,
  className,
  ...rest
}: CustomButtonProps) => {
  const onClickHandler = useButtonNavHandler(path);

  return (
    <Button
      {...rest}
      onClick={onClickHandler ?? rest.onClick}
      {...rest}
      className={`${className ? `${className} ` : ''}btn-primary btn-animated`}
    >
      {children}
    </Button>
  );
};
